import React, {FC} from 'react';
import MobileWrapper from 'components/Header/MobileWrapper';

import {NavProps} from '..';

import Lines from './svgs/lines.inline.svg';
import MobileNav from './MobileNav';

import * as styles from './styles.module.scss';

const SiteNav: FC<NavProps> = ({nav}) => (
	<div className={styles.wrapper} onClick={nav.open}>
		<Lines />
		{nav.active && (
			<MobileWrapper side='left' onClose={nav.close}>
				<MobileNav nav={nav} />
			</MobileWrapper>
		)}
	</div>
);

export default SiteNav;
